import { DatePipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner'
import { MessageService } from 'primeng/api'
import { combineLatest } from 'rxjs'
import { environment } from '../../../../../../environments/environment'
import { DataPageOfDocument, UiPreferences } from '../../../../../api/models'
import { AppSettingService, DocumentService } from '../../../../../api/services'
import { Customsort } from '../../../../directives/customsort'
import { SelectedPatientService } from '../../patient-list/patient-service'
import { CareFinitySession } from '../../../../services/CareFinitySession'

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.css'],
})
export class DocumentListComponent implements OnInit {
  Item = 'Documents'
  documents: DataPageOfDocument
  selectedPatient: Document

  rows: number
  _selectedColumns: any[]
  displaypopup: boolean = false
  private cols: any[]

  pdfSrc: any
  href: string
  visible: boolean
  showDialog: boolean
    isActive: boolean = true // Set initial state here

    preferences: UiPreferences = {};

    setPrintFlag: boolean = false;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private messageService: MessageService,
    private docservice: DocumentService,
    public activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private cstsort: Customsort,
    private selectedPatientService: SelectedPatientService,
    private appSettingsService: AppSettingService,
  ) {}

  ngOnInit() {
    this.cols = [
      { field: 'visitDate', header: 'Visit Date' },
      { field: 'description', header: 'Description' },
      { field: 'createdbyName', header: 'Created By' },
      { field: 'createdOn', header: 'Create Date' },
      { field: 'format', header: 'Format' },
    ]

      this.loadDocumentList(1, 'Desc');

    

      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          this.Item = this.preferences?.documents || 'Documents';
      }



     



  }
  loadDocumentList(pageNumber: number, sortbydirection: string) {
    this.docservice
      .documentList({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
        sortbydirection: sortbydirection,
      })
      .subscribe((result) => {
        this.documents = result

        this.rows = this.documents.pageSize
      })
  }

  toggleActivation($event) {
    this.isActive = $event.checked
    this.router.navigateByUrl('/Patient/documents/catlist')
  }
  formatdatetime(item, type) {
    if (item != null && type.indexOf('Date') > -1) {
      return this.datePipe.transform(item, environment.datetimeformat)
    }
    return item
  }

  viewDoc(rowData: any) {
    this.docservice
      .documentDetail({
        Id: rowData.fileName,
        Description: rowData.description,
        DBIndic: rowData.databaseIndic,
        fileFormat: rowData.format,
        DocumentType: rowData.documentType,
        Location: rowData.location,
        VisitDate: rowData.visitDate,
        PracticeId: localStorage.getItem('EmrPracticeId'),
        PatientId: this.selectedPatientService.getPatientValue().patientId,
      })
      .subscribe(
        (documentDetails) => {
          this.docservice
            .documentGetDocuments({
              fn: documentDetails.docName,
              PatientName: sessionStorage.getItem('ptName'),
            })
            .subscribe(
              (file) => {
                if (documentDetails.flexPaper) {
                  this.router.navigate(['show-pdf'], {
                    relativeTo: this.activatedRoute,
                    state: {
                      pdf: file,
                        showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
                        enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user?.roles?.enableDocumentDownloads

                    },
                  })
                } else {
                  const binaryData = [file]
                  const downloadLink = document.createElement('a')
                  downloadLink.href = window.URL.createObjectURL(
                    new Blob(binaryData, { type: file.type }),
                  )
                  downloadLink.target = '_blank'
                  downloadLink.setAttribute('inline', 'arshid')
                  document.body.appendChild(downloadLink)
                  downloadLink.click()
                  document.body.removeChild(downloadLink) // Clean up
                }
              },
              (err) => {
                this.messageService.add({
                  key: 'alertToast',
                  severity: 'error',
                  summary: 'ERROR',
                  detail:
                    'Document File missing, Please Contact Technical Support',
                })
              },
            )

          console.log(documentDetails)
        },
        (err) => {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: 'Document File missing, Please Contact Technical Support',
          })
        },
      )
  }

  back() {
    window.history.back()
  }
}
